import { injectable } from 'inversify';
import type { ISupportTicketRepository, SupportTicketDTO, UpdateTicketDTO } from '@/domain/repositories/ISupportTicketRepository';
import { httpClient } from '@/infrastructure/http/client/httpClient';

@injectable()
export class ApiSupportTicketRepository implements ISupportTicketRepository {
  async getAll(tenantId?: string): Promise<SupportTicketDTO[]> {
    const params = tenantId ? `?tenantId=${encodeURIComponent(tenantId)}` : '';
    const response = await httpClient.get<SupportTicketDTO[]>(`/support/tickets${params}`);
    return response.data;
  }

  async getById(id: string): Promise<SupportTicketDTO> {
    const response = await httpClient.get<SupportTicketDTO>(`/support/tickets/${encodeURIComponent(id)}`);
    return response.data;
  }

  async update(id: string, data: UpdateTicketDTO): Promise<SupportTicketDTO> {
    const response = await httpClient.patch<SupportTicketDTO>(`/support/tickets/${encodeURIComponent(id)}`, data);
    return response.data;
  }
}
